
    import {computed, ComputedRef, defineComponent, reactive, watch} from 'vue'
    import {useStore} from "@/store";
    import {useRoute} from "vue-router";

    interface State {
        sealType: string; // 是否有闲鱼优品印章
        reportLevel: number;
        carImg: string;
        carModel: string;
        vin: string;
    }

    export default defineComponent({
        name: "reportCarInfo",
        setup() {
            let state: State = reactive({
                sealType: '',
                reportLevel: 0,
                carImg: '',
                carModel: '',
                vin: '',
            })
            const {query} = useRoute();
            let store = useStore();
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            watch(dataInfo,(data: any) => {
                const {modelName, vin, photoList} = data;
                state.sealType = `${query.sealType}` || '';
                state.reportLevel = Number(`${query.reportLevel}`) || 0;
                state.vin = vin;
                state.carModel = modelName;
                let carImgObj = photoList.filter(function(item: any){
                    return item.photoCode == "SP1"; 
                })
                state.carImg = carImgObj[0].smallPhotoUrl;
            })
            return {
                state
            }
        },
        methods: {},
    })
